/**
 * Consenso cookie non necessari (oggi: solo Google Analytics), su localStorage.
 * `null` = nessuna scelta ancora fatta (banner visibile). Store minimo con
 * useSyncExternalStore invece di Context/libreria esterna: due soli stati,
 * letti da 3 punti (banner, loader GA, link "gestisci preferenze" in footer/
 * Cookie Policy) che devono restare sincronizzati senza prop drilling.
 */

export type CookieConsent = "accepted" | "rejected" | null;

const STORAGE_KEY = "il-pozzo-cookie-consent";

const listeners = new Set<() => void>();
let cached: CookieConsent = null;
let hydrated = false;

function readStoredConsent(): CookieConsent {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw === "accepted" || raw === "rejected" ? raw : null;
  } catch {
    // Storage non disponibile (private mode, policy del browser): nessuna
    // scelta persistita, il banner ricompare ad ogni visita.
    return null;
  }
}

function ensureHydrated(): void {
  if (hydrated) return;
  cached = readStoredConsent();
  hydrated = true;
}

export function subscribeCookieConsent(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getCookieConsentSnapshot(): CookieConsent {
  ensureHydrated();
  return cached;
}

/** SSR: nessuna preferenza nota lato server, il client la idrata al mount. */
export function getCookieConsentServerSnapshot(): CookieConsent {
  return null;
}

export function setCookieConsent(value: CookieConsent): void {
  cached = value;
  hydrated = true;
  try {
    if (value === null) {
      window.localStorage.removeItem(STORAGE_KEY);
    } else {
      window.localStorage.setItem(STORAGE_KEY, value);
    }
  } catch {
    // Scelta valida solo per questa pagina (storage bloccato); non blocchiamo l'interazione.
  }
  listeners.forEach((listener) => listener());
}
